<ws-modal-wrapper headerLabel="Process - Appeal Warranted"
                  acceptLabel="Process"
                  [cancelLabel]="cancelLabel"
                  [hideSave]="!appealLevels"
                  [disableSave]="loading || !!validationMessage"
                  [disableCancel]="loading"
                  [loading]="loading"
                  (save)="process()"
                  (cancel)="cancel()">
    @if (loading && loadingMessage) {
        <h4 class="text-center mt-4">{{ loadingMessage }}</h4>
    }
    @if (!loading && payload) {
        <div>
            @if (isClientApprovalRequired) {
                <p class="lead text-danger mb-0">Please confirm client approval has been received prior to
                    processing.</p>
            }
            @if (validationMessage) {
                <p class="lead text-danger mb-0">{{ validationMessage }}</p>
            }
            @if (appealLevels) {
                <div>
                    <label>Appeal Level:</label>
                    <ws-select [options]="appealLevels"
                               labelProperty="abbr"
                               valueProperty="appealLevelID"
                               [(ngModel)]="payload.appealLevelID"
                               (ngModelChange)="onAppealLevelChange()">
                    </ws-select>
                     <div class="mt-1">
                        <span>Litigation: {{ isSelectedAppealLevelLitigation ? 'Yes' : 'No' }}</span>
                    </div>
                    @if (shouldShowLitigationReferralCheckbox) {
                        <!-- <p class="mt-2 mb-0 text-warning">The selected appeals will be eligible for a litigation referral.</p> -->
                        <div class="form-check d-flex align-items-center gap-2 mt-2">
                            <input type="checkbox" id="ryanLegalServices" class="form-check-input mt-0" [(ngModel)]="litigationReferralChecked" (ngModelChange)="onLitigationReferralChange()" />
                            <label class="form-check-label mb-0" for="ryanLegalServices">{{ litigationReferralLabel }}</label>
                        </div>
                    }

             <div class="mt-3">
                <strong>Set Assessment Description to:</strong>
             </div>
               <div class="radio">
                <label>
                    <input type="radio" [(ngModel)]="payload.revisionChangeTypeID" [value]="revisionChangeTypes.OTHER" >
                    Other
                </label>
                <input type="text"
                       #other
                       name="other"
                       [(ngModel)]="payload.newRevisionDescription"
                       class="form-control d-inline-block ms-3 mb-0">
            </div>
            <div class="radio">
                <label>
                    <input type="radio" [(ngModel)]="payload.revisionChangeTypeID" [value]="revisionChangeTypes.NO_CHANGE">
                    No Change
                </label>
            </div>


                    <div class="row mt-3">
                        <div class="col-lg-2">
                            Comment:
                        </div>
                        <div class="col-lg-10">
              <textarea class="form-control mb-3"
                        cols="40"
                        rows="5"
                        [(ngModel)]="payload.comment"
                        (ngModelChange)="onCommentChange()">
              </textarea>
                        </div>
                    </div>
                    @if (hasCommentText) {
                        <div class="checkbox">
                            <label for="pin-comment">
                                <input id="pin-comment" type="checkbox" [(ngModel)]="payload.isPinned">
                                Pin Comment
                            </label>
                        </div>
                    }
                </div>
            }
        </div>
    }
</ws-modal-wrapper>
